import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

// Self-hosted fonts — replaces the Google Fonts + jsDelivr @mdi/font CDN <link>s
// removed from public/index.html. Required so the air-gapped on-prem report-web
// renders identically to the cloud (weights match the old CDN Roboto request).
import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'
import '@mdi/font/css/materialdesignicons.css'

// 全域 print media 樣式（紙張設定在 LegacyRenderer.vue）；刻意不經 main.scss／prependData，只 import 一次
import '@/assets/css/report-print.css'

import VueCookies from 'vue-cookies'
import router from './routes'
import store from '@/stores'

// directives
import imageLazyLoad from './directives/image-lazy-load'

// lang settings
import i18n from '@/lang'

import conzianTimeHandler from '@/utils/conzian-time-handler.js'
import systemFuncs from '@/utils/system'

Vue.config.productionTip = false

Vue.directive('lazyload', imageLazyLoad)

Vue.use(VueCookies)
Vue.use(conzianTimeHandler)
Vue.use(systemFuncs)

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
